import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import Faq from './Faq';
import ManageKnowlegde from './Document'
import GenerativeAI from './GenerativeAI';
import KnowledgeDocument from './KnowledgeDocument';
import WebsiteReading from './WebsiteReading';

class FaqSubTabSetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/manage-knowledge";
            var path1 = window.origin + "/platform/projectmgmt/manage-knowledge/";
            if (currentPath === path || currentPath === path1) {
                $("#manage-knowlegde-document").addClass('active');
            } else if (currentPath.includes('/projectmgmt/manage-knowledge/agent')) {
                $("#manage-knowlegde-agent").addClass('active');
            } else if (currentPath.includes('/projectmgmt/manage-knowledge/faq')) {
                $("#manage-knowlegde-faq").addClass('active');
            } else if (currentPath.includes('/projectmgmt/manage-knowledge/website-reading')) {
                $("#manage-knowlegde-website-reading").addClass('active');
            } $("#manage-knowlegde-document,#manage-knowlegde-faq, #manage-knowlegde-agent, #manage-knowlegde-website-reading")
                .on("click", function () {
                    $("#manage-knowlegde-document,#manage-knowlegde-faq, #manage-knowlegde-agent, #manage-knowlegde-website-reading")
                        .removeClass('active');
                    localStorage.setItem("last-used-faq-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage" >
                <div className="content" >

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="content-header" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5">
                                    <h1 className="m-0 page-title">Knowledge Management</h1>
                                    <h6 className="taglineTxt">Faq &amp; Document</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid" >
                        <div className="border-bottom"></div>
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                {/* <Link className="nav-item" data-toggle="tab" to="/projectmgmt/manage-knowledge" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="manage-knowlegde-document">
                                        Documents
                                    </li>
                                </Link> */}
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/manage-knowledge" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="manage-knowlegde-document">
                                        Documents/Content
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/manage-knowledge/website-reading" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="manage-knowlegde-website-reading">
                                        Website reading
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/manage-knowledge/agent" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="manage-knowlegde-agent">
                                        Global Prompt
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/manage-knowledge/faq" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="manage-knowlegde-faq">
                                        FAQ
                                    </li>
                                </Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/manage-knowledge/website-reading" component={WebsiteReading}></Route>
                    <Route exact path="/projectmgmt/manage-knowledge/agent" component={GenerativeAI}></Route>
                    <Route path="/projectmgmt/manage-knowledge/faq" component={Faq}></Route>
                    {/* <Route path="/projectmgmt/manage-knowledge" component={ManageKnowlegde}></Route> */}
                    <Route path="/projectmgmt/manage-knowledge" component={KnowledgeDocument}></Route>
                </Switch>
            </div>

        );
    }
}
export default FaqSubTabSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/faq/FaqSubTabSetting.js